import React from 'react';
import { DialogContent } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useAppState } from 'store/Provider';
import EditTotalWorkunit from '../ChangeBaselinePages/NewBaseline/EditTotalWorkunit/EditTotalWorkunit';
import { useSelector } from 'store/hooks';
import { changePageAction, changePageSizeAction, filterTotalFlagAction } from 'store/actions/changeBaselineActions';
import useBaseLineOrderWorkunitApi from '../ChangeBaselinePages/services/useBaseLineOrderWorkunitApi';

const BaselineTotalWorkunit = () => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const { getBLOrderNewWorkunits } = useBaseLineOrderWorkunitApi();
  const isOpen = dialogs.changeBaselinetotalWorkunitDialog;
  const scopes = useSelector((state) => state.catalogToOrder.scopes);
  const { sourceOrder, baseLineOrder } = useSelector((state) => state.changeBaseline);
  const [t] = useTranslation();

  const dialogBody = (
    <DialogContent>
      <EditTotalWorkunit scopes={scopes} />
    </DialogContent>
  );

  const closedBaseWorkunit = () => {
    const baselineVersion =
      sourceOrder?.baseline_version === 0 || sourceOrder?.baseline_version === null
        ? 1
        : Number(sourceOrder?.baseline_version) + 1;
    getBLOrderNewWorkunits(Number(baseLineOrder?.id), 2, Number(sourceOrder?.id), baselineVersion);
    dispatch(filterTotalFlagAction(false));
    dispatch(closeDialogAction('changeBaselinetotalWorkunitDialog'));
    dispatch(changePageSizeAction(50));
    dispatch(changePageAction(0));
  };

  const actions = <></>;
  return (
    <ModalCustom
      open={isOpen}
      modalName="changeBaselinetotalWorkunitDialog"
      onClose={() => closedBaseWorkunit()}
      onCloseEvent={closedBaseWorkunit}
      titleText="Total Workunits"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: document.documentElement.clientWidth, // Set your width here
          },
        },
      }}
      actions={actions}
      body={dialogBody}
      size="lg"
      confirmLoad
    />
  );
};

export default BaselineTotalWorkunit;
